<template>
  <modal-form v-model='show'>
    <template v-slot:title>
      <span v-html="(response.errorDescription || response.errorCode) || 'Erro desconhecido'"></span>
    </template>
    <template v-slot:body>
      <v-row>
      <span v-html="getErroDescription"></span>
      </v-row>
    </template>
    <template v-slot:actions>
      <div class='flex-grow-1'></div>
      <v-btn
        color='white'
        @click='close()'
        v-if='
          blocked.includes(response.errorDetailCode) ||
          changePassword.includes(response.errorDetailCode)
        '
      >
        Voltar
      </v-btn>
      <v-btn
        color='primary'
        to='/lembrar'
        v-if='changePassword.includes(response.errorDetailCode)'
      >
        Alterar senha
      </v-btn>
      <v-btn
        color='primary'
        @click='follow()'
        v-if='allowed.includes(response.errorDetailCode)'
      >
        Continuar
      </v-btn>
    </template>
  </modal-form>
</template>

<script>
export default {
  data () {
    return {
      changePassword: ['CTL-002', 'CTL-007'],
      blocked: ['CTL-001', 'CTL-003', 'CTL-004', 'CTL-005', 'CTL-006'],
      allowed: ['CTL-007'],
      show: false,
      response: {},
      errorMessage: '',
    };
  },
  methods: {
    openModal (sender) {
      if (sender) {
        this.response = sender;
      }
      this.show = true;
    },
    close () {
      this.show = false;
      this.erroInfo = {};
      this.erroMessage = '';
    },
    follow () {
      const th = this;
      th.$emit('follow', th.response)
    },
  },
  computed: {
    getErroDescription () {
      switch (this.response.errorDetailCode) {
        case 'CTL-001':
          return 'Usuário está bloqueado. Tempo de inatividade excedido. Entre em contato com o suporte para ativação.';
        case 'CTL-002':
          return 'Senha expirada. Para continuar, altere sua senha.';
        case 'CTL-003':
          return 'Usuário está bloqueado.';
        case 'CTL-004':
        case 'CTL-005':
        case 'CTL-006':
          return '<p>Login ou senha informados estão incorretos. Por favor, revise os dados inseridos e tente novamente, você também pode tentar redefinir a sua senha <b><a target="_blank" href="/lembrar">clicando aqui.</a></b></p>';
        case 'CTL-007':
          return 'Sua senha irá expirar em breve.';
        default:
          return 'Entre em contato com o suporte.';
      }
    },
  },
};
</script>
